/**
 * Contain the Style for the Login View
 */

//ColorManager
import ColorManager from "./../managers/ColorManager";

export default {

    title: {
        color: ColorManager.primaryColor,
        textAlign: "center"
    },

    errorMessage: {
        alignItems: "center",
        color: ColorManager.error,
        display: "flex",
        justifyContent: "center",
        marginTop: "16px"
    },

    formContainer : {
        padding: "16px"
    },

    inputContainer : {
        marginBottom: "8px",
        marginTop: "8px",
        width: "100%"
    },

    loginButton : {
        backgroundColor: ColorManager.primaryColor,
        color: ColorManager.text,
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "16px"
    }
};



// WEBPACK FOOTER //
// ./src/app/styles/Login.ts